export interface Chapter {
  id: number;
  comicId: number;
  number: number;
  title: string;
  updateTime: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updateTime: string;
  tags: string[];
  chapters: Chapter[];
}

function generateChapters(comicId: number, count: number): Chapter[] {
  const chapters: Chapter[] = [];
  const now = new Date('2026-08-05');
  for (let i = count; i >= 1; i--) {
    const updateDate = new Date(now);
    updateDate.setDate(updateDate.getDate() - (count - i) * 4);
    chapters.push({
      id: comicId * 1000 + i,
      comicId,
      number: i,
      title: `第${i}话`,
      updateTime: updateDate.toISOString().split('T')[0],
    });
  }
  return chapters;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '霸总的心尖宠',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20cover%20illustration%20featuring%20a%20handsome%20CEO%20man%20in%20a%20luxurious%20black%20suit%20holding%20a%20delicate%20woman%20in%20a%20flowing%20dress%2C%20romantic%20atmosphere%20with%20soft%20golden%20lighting%2C%20rose%20petals%20falling%2C%20elegant%20manhwa%20art%20style%2C%20warm%20toned%20background%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    description: '冷酷霸总苏宁宇在一次意外中救下了平凡女孩金多美，从此命运的齿轮开始转动。面对着集团内部的权力斗争和家族的重重阻碍，两人能否守护彼此？一段充满甜蜜与虐心的爱情故事即将展开。',
    status: '连载中',
    rating: 4.8,
    views: 1520000,
    updateTime: '2026-08-04',
    tags: ['霸总', '甜宠', '契约婚姻', '都市'],
    chapters: generateChapters(1, 68),
  },
  {
    id: 2,
    title: '异世界咖啡厅',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20fantasy%20webtoon%20cover%20showing%20a%20cozy%20magical%20cafe%20with%20floating%20candles%20and%20a%20young%20female%20barista%20in%20an%20apron%20with%20pointed%20elf%20ears%2C%20various%20fantasy%20creatures%20as%20customers%2C%20warm%20amber%20glow%2C%20manhwa%20art%20style%2C%20clean%20simple%20background&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '社畜李夏恩在一场意外中穿越到了魔法异世界，唯一的生存技能竟然是在现代学会的咖啡拉花？在精灵与龙族出没的世界里，她用一杯杯温暖咖啡征服了异世界的味蕾，也遇见了神秘的黑魔法师。',
    status: '连载中',
    rating: 4.6,
    views: 980000,
    updateTime: '2026-08-03',
    tags: ['异世界', '美食', '魔法', '日常'],
    chapters: generateChapters(2, 52),
  },
  {
    id: 3,
    title: '剑圣归来',
    author: '朴太贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20webtoon%20cover%20with%20a%20powerful%20male%20swordsman%20in%20traditional%20martial%20arts%20robe%20holding%20a%20glowing%20sword%2C%20dramatic%20wind%20effects%2C%20energy%20waves%20surrounding%20him%2C%20intense%20expression%2C%20dark%20stormy%20background%2C%20epic%20manhwa%20art%20style%2C%20clean%20composition&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    category: 'action',
    description: '曾经被誉为天下第一剑的崔正宇在一次大战中陨落，百年后重生为一个废柴少年。前世的记忆仍在，剑道感悟犹存，这一次他要重新登顶武道巅峰，向曾经的敌人复仇！',
    status: '连载中',
    rating: 4.9,
    views: 2100000,
    updateTime: '2026-08-05',
    tags: ['重生', '武侠', '复仇', '热血'],
    chapters: generateChapters(3, 85),
  },
  {
    id: 4,
    title: '她的秘密花园',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=A%20tender%20Korean%20drama%20webtoon%20cover%20depicting%20a%20young%20woman%20with%20tears%20in%20her%20eyes%20standing%20in%20a%20beautiful%20garden%20full%20of%20white%20flowers%2C%20looking%20back%20at%20a%20departing%20man%2C%20soft%20pastel%20colors%2C%20emotional%20atmosphere%2C%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    category: 'drama',
    description: '女大学生林雪儿在一个雨夜捡到了一本神秘日记，日记的主人是一位身患绝症的女孩。出于好奇，她开始追寻日记中的故事，却意外卷入了一段尘封已久的往事和一场跨越生死的爱恋。',
    status: '已完结',
    rating: 4.7,
    views: 1350000,
    updateTime: '2026-07-20',
    tags: ['治愈', '悬疑', '青春', '催泪'],
    chapters: generateChapters(4, 46),
  },
  {
    id: 5,
    title: '午夜诊所',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20chilling%20Korean%20thriller%20webtoon%20cover%20showing%20a%20mysterious%20doctor%20in%20white%20coat%20standing%20in%20a%20dimly%20lit%20clinic%20corridor%20at%20midnight%2C%20red%20emergency%20light%20casting%20shadows%2C%20eerie%20atmosphere%2C%20dark%20horror%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    category: 'thriller',
    description: '在一栋废弃医院的地下三层，有一家只在午夜开放的诊所。凡是来这里求医的人，都能治愈身体上的疾病，但代价是交出自己最珍贵的记忆。实习医生朴信宇无意间发现了这个秘密，他决定揭开真相。',
    status: '连载中',
    rating: 4.5,
    views: 870000,
    updateTime: '2026-08-02',
    tags: ['恐怖', '悬疑', '医学', '都市传说'],
    chapters: generateChapters(5, 38),
  },
  {
    id: 6,
    title: '废柴逆袭记',
    author: '吴世勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20webtoon%20cover%20with%20a%20goofy%20looking%20young%20man%20in%20oversized%20tracksuit%20making%20a%20silly%20face%2C%20holding%20a%20gaming%20controller%2C%20colorful%20explosion%20effects%20in%20background%2C%20vibrant%20and%20playful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    category: 'comedy',
    description: '游戏宅男金太宇的人生目标就是每天打游戏到凌晨三点，直到有一天他被强制征召进入了一个真人版RPG系统。在这个世界里，他的游戏经验竟然成了最强的生存技能！废柴的逆袭之路，笑料百出。',
    status: '连载中',
    rating: 4.3,
    views: 720000,
    updateTime: '2026-08-04',
    tags: ['搞笑', '系统流', '游戏', '逆袭'],
    chapters: generateChapters(6, 55),
  },
  {
    id: 7,
    title: '猫咪咖啡馆',
    author: '崔智友',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20slice%20of%20life%20webtoon%20cover%20showing%20a%20young%20woman%20sitting%20in%20a%20sunny%20cat%20cafe%20surrounded%20by%20various%20cute%20cats%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20cozy%20and%20peaceful%20atmosphere%2C%20soft%20pastel%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    category: 'slice-of-life',
    description: '辞职后的赵敏儿接手了一家濒临倒闭的猫咪咖啡馆。在经营咖啡馆的日子里，她遇到了各种各样的人和猫，每个客人和猫咪背后都有着温暖治愈的小故事。生活或许平凡，但总有小确幸。',
    status: '已完结',
    rating: 4.6,
    views: 650000,
    updateTime: '2026-06-30',
    tags: ['治愈', '猫咪', '美食', '日常'],
    chapters: generateChapters(7, 40),
  },
  {
    id: 8,
    title: '星辉之恋',
    author: '沈银河',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20BL%20webtoon%20cover%20depicting%20two%20elegant%20young%20men%20in%20formal%20attire%20standing%20under%20a%20starry%20night%20sky%2C%20one%20resting%20his%20head%20on%20the%20others%20shoulder%2C%20soft%20moonlight%20and%20stars%2C%20ethereal%20atmosphere%2C%20beautiful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    category: 'bl',
    description: '顶流偶像团体Stellar的主唱尹星辉与新人演员姜瑞宇在一次综艺节目中意外合作，台上营业的甜蜜互动在台下渐渐变成了真实的心动。然而娱乐圈的风波和人气的压力，让这段感情步履维艰。',
    status: '连载中',
    rating: 4.8,
    views: 1890000,
    updateTime: '2026-08-05',
    tags: ['娱乐圈', '偶像', '纯爱', '虐心'],
    chapters: generateChapters(8, 72),
  },
  {
    id: 9,
    title: '重生之豪门千金',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20romance%20webtoon%20cover%20featuring%20an%20elegant%20woman%20in%20a%20stunning%20red%20evening%20gown%20standing%20in%20a%20grand%20luxurious%20ballroom%2C%20chandelier%20lighting%2C%20confident%20expression%2C%20sophisticated%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    category: 'romance',
    description: '前世被继母和继妹陷害致死的豪门千金韩素妍，重生回到了十八岁那年。这一次她不会再做任人宰割的羔羊，她要用前世的记忆改写命运，让所有害过她的人都付出代价。',
    status: '连载中',
    rating: 4.7,
    views: 1680000,
    updateTime: '2026-08-04',
    tags: ['重生', '豪门', '复仇', '逆袭'],
    chapters: generateChapters(9, 60),
  },
  {
    id: 10,
    title: '龙族学院',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20Korean%20fantasy%20webtoon%20cover%20showing%20students%20in%20academy%20uniforms%20at%20a%20school%20built%20on%20a%20floating%20island%2C%20dragons%20flying%20in%20the%20sky%2C%20a%20young%20male%20protagonist%20with%20dragon%20scales%20on%20his%20arm%2C%20epic%20fantasy%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    category: 'fantasy',
    description: '普通高中生韩志浩因为体内觉醒了龙族血脉，被强制转学到了位于异空间的龙族学院。在这里人类与龙族的混血后裔们学习控制自己的力量，而一股黑暗势力正悄然逼近。',
    status: '连载中',
    rating: 4.5,
    views: 1050000,
    updateTime: '2026-08-03',
    tags: ['学院', '龙族', '异能', '冒险'],
    chapters: generateChapters(10, 48),
  },
  {
    id: 11,
    title: '地下拳王',
    author: '朴太贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20gritty%20Korean%20action%20webtoon%20cover%20with%20a%20muscular%20fighter%20in%20a%20dark%20underground%20boxing%20ring%2C%20sweat%20and%20blood%2C%20dramatic%20spotlight%2C%20intense%20eyes%2C%20bandaged%20fists%2C%20raw%20and%20powerful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    category: 'action',
    description: '前职业拳击手姜泰浩因为一场假赛被剥夺了职业资格，生活陷入绝境。为了给患病的妹妹筹集医药费，他走上了地下黑拳的擂台。每一场比赛都是生死之战，他能否在黑暗世界中杀出一条血路？',
    status: '连载中',
    rating: 4.8,
    views: 1320000,
    updateTime: '2026-08-05',
    tags: ['格斗', '热血', '亲情', '生存'],
    chapters: generateChapters(11, 56),
  },
  {
    id: 12,
    title: '时间的缝隙',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20drama%20webtoon%20cover%20showing%20a%20pocket%20watch%20shattering%20into%20pieces%2C%20a%20man%20and%20woman%20reaching%20for%20each%20other%20through%20cracks%20in%20time%2C%20clock%20gears%20floating%2C%20dreamy%20surreal%20atmosphere%2C%20emotional%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    category: 'drama',
    description: '在同样的地铁站，程序员姜允浩每天早上8点15分都会遇见同一个女孩。四年如一日，他们从未说过话。直到有一天，他收到了一只可以倒流时间的怀表，却发现每一次改变过去，都要付出巨大的代价。',
    status: '已完结',
    rating: 4.9,
    views: 2010000,
    updateTime: '2026-05-15',
    tags: ['时间旅行', '爱情', '催泪', '奇幻'],
    chapters: generateChapters(12, 36),
  },
  {
    id: 13,
    title: '鬼怪公寓',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20spooky%20Korean%20thriller%20webtoon%20cover%20depicting%20an%20old%20apartment%20building%20at%20night%20with%20ghostly%20figures%20in%20windows%2C%20a%20young%20man%20with%20a%20flashlight%20entering%20the%20building%2C%20fog%20creeping%20on%20the%20ground%2C%20haunting%20atmosphere%2C%20dark%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-13&orientation=portrait',
    category: 'thriller',
    description: '因为房租便宜，大学生金珉奎毫不犹豫地搬进了南山公寓404号房。入住第一晚，他就发现这个公寓不对劲——走廊里总会传来小孩的嬉笑声，而整栋楼除了他之外，似乎没有其他活人。',
    status: '连载中',
    rating: 4.4,
    views: 760000,
    updateTime: '2026-08-01',
    tags: ['灵异', '公寓', '悬疑', '恐怖'],
    chapters: generateChapters(13, 42),
  },
  {
    id: 14,
    title: '我成了反派他妈妈',
    author: '吴世勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20hilarious%20Korean%20comedy%20webtoon%20cover%20showing%20a%20panicked%20young%20woman%20holding%20a%20mischievous%20little%20boy%20in%20noble%20clothing%2C%20speech%20bubbles%20with%20exclamation%20marks%2C%20cartoonish%20expressions%2C%20bright%20colorful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-14&orientation=portrait',
    category: 'comedy',
    description: '熬夜看完一部狗血小说的赵允熙，一觉醒来发现自己穿越进了书里——而且成了那个注定惨死的反派角色的妈妈！为了不让儿子变成书中的大反派，她决定用爱与美食把孩子掰回正道。',
    status: '连载中',
    rating: 4.6,
    views: 1280000,
    updateTime: '2026-08-04',
    tags: ['穿书', '育儿', '搞笑', '治愈'],
    chapters: generateChapters(14, 50),
  },
  {
    id: 15,
    title: '画家的调色盘',
    author: '崔智友',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20slice%20of%20life%20webtoon%20cover%20with%20a%20female%20artist%20painting%20at%20an%20easel%20in%20a%20sunlit%20studio%2C%20colorful%20paint%20splatters%2C%20canvases%20around%20her%2C%20warm%20afternoon%20light%2C%20artistic%20and%20peaceful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-15&orientation=portrait',
    category: 'slice-of-life',
    description: '失明的天才画家白秀雅在角膜移植手术后重获光明，却发现她看到的颜色和别人的不一样——她能看见人们情绪的颜色。这份特殊的能力让她成为了一名"情绪画师"，用画笔治愈都市人的心灵。',
    status: '已完结',
    rating: 4.7,
    views: 890000,
    updateTime: '2026-07-10',
    tags: ['艺术', '治愈', '超能力', '日常'],
    chapters: generateChapters(15, 44),
  },
  {
    id: 16,
    title: '绯月之下',
    author: '沈银河',
    cover: 'https://readdy.ai/api/search-image?query=A%20melancholic%20Korean%20BL%20webtoon%20cover%20with%20two%20men%20embracing%20under%20a%20crimson%20moon%2C%20one%20wearing%20traditional%20Korean%20hanbok%2C%20the%20other%20in%20modern%20clothing%2C%20cherry%20blossoms%20falling%2C%20bittersweet%20atmosphere%2C%20elegant%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-16&orientation=portrait',
    category: 'bl',
    description: '考古系研究生李瑞元在发掘一座古墓时意外唤醒了沉睡千年的高丽王朝大将军，这位古代将军对现代世界一无所知，却对李瑞元产生了强烈的保护欲。跨越千年的羁绊，前世今生的纠葛。',
    status: '连载中',
    rating: 4.9,
    views: 1950000,
    updateTime: '2026-08-05',
    tags: ['穿越', '古风', '前世今生', '虐恋'],
    chapters: generateChapters(16, 64),
  },
  {
    id: 17,
    title: '契约恋人',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20romance%20webtoon%20cover%20featuring%20a%20couple%20signing%20a%20contract%20at%20a%20fancy%20restaurant%20table%2C%20both%20looking%20at%20each%20other%20with%20hidden%20affection%2C%20city%20nightscape%20through%20window%2C%20modern%20sophisticated%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-17&orientation=portrait',
    category: 'romance',
    description: '为了应付双方父母的催婚压力，职场精英崔敏浩和自由设计师李多美签订了一份为期一年的"契约恋爱"协议。规则很简单：不产生真感情。然而，朝夕相处中，心动的频率正在失控。',
    status: '连载中',
    rating: 4.5,
    views: 1150000,
    updateTime: '2026-08-03',
    tags: ['契约恋爱', '假戏真做', '都市', '甜宠'],
    chapters: generateChapters(17, 45),
  },
  {
    id: 18,
    title: '魔王的继承者',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20Korean%20fantasy%20webtoon%20cover%20showing%20a%20young%20man%20with%20dark%20wings%20emerging%20from%20his%20back%20sitting%20on%20a%20throne%20made%20of%20bones%2C%20demonic%20energy%20swirling%2C%20red%20and%20black%20color%20scheme%2C%20powerful%20dark%20fantasy%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-18&orientation=portrait',
    category: 'fantasy',
    description: '人族与魔族的战争持续了千年，人族少年林宇轩在一次战役中被魔族俘虏。令人震惊的是，魔王在他身上感受到了纯正的魔族血脉——他是魔王遗失在人间的继承人。两个种族的命运，压在了他的肩上。',
    status: '连载中',
    rating: 4.7,
    views: 1450000,
    updateTime: '2026-08-04',
    tags: ['魔幻', '战争', '身份之谜', '史诗'],
    chapters: generateChapters(18, 70),
  },
  {
    id: 19,
    title: '正义代言人',
    author: '朴太贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20serious%20Korean%20action%20webtoon%20cover%20with%20a%20determined%20lawyer%20holding%20a%20briefcase%20in%20one%20hand%20and%20clenching%20fist%20with%20the%20other%2C%20courtroom%20scales%20of%20justice%20in%20background%2C%20dramatic%20lighting%2C%20intense%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-19&orientation=portrait',
    category: 'action',
    description: '曾是特种兵的姜律师，用法律武器对抗那些法律无法制裁的恶人。白天他是法庭上口若悬河的辩护人，夜晚他化身正义的使者，用拳头为受害者讨回公道。法律与正义，他选择两者都要。',
    status: '已完结',
    rating: 4.6,
    views: 1100000,
    updateTime: '2026-06-20',
    tags: ['律政', '复仇', '动作', '悬疑'],
    chapters: generateChapters(19, 58),
  },
  {
    id: 20,
    title: '社内恋爱禁止令',
    author: '吴世勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20playful%20Korean%20comedy%20webtoon%20cover%20showing%20an%20office%20setting%20where%20a%20couple%20is%20hiding%20behind%20cubicle%20walls%20trying%20not%20to%20get%20caught%2C%20comical%20expressions%2C%20sneaky%20atmosphere%2C%20bright%20office%20lighting%2C%20funny%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-20&orientation=portrait',
    category: 'comedy',
    description: '顶级游戏公司"星辰互娱"有一条铁律：员工之间禁止恋爱。然而新来的HR总监偏偏是公司最帅的程序员的前女友。更糟糕的是，他们被分配到了同一个项目组，每天都要假装彼此不认识。',
    status: '连载中',
    rating: 4.4,
    views: 980000,
    updateTime: '2026-08-02',
    tags: ['职场', '办公室恋情', '搞笑', '欢喜冤家'],
    chapters: generateChapters(20, 40),
  },
  {
    id: 21,
    title: '深海之下',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20thriller%20webtoon%20cover%20depicting%20a%20deep%20sea%20research%20facility%20with%20a%20giant%20shadow%20of%20an%20unknown%20creature%20looming%20outside%20the%20window%2C%20scientists%20looking%20terrified%2C%20dark%20blue%20underwater%20atmosphere%2C%20suspenseful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-21&orientation=portrait',
    category: 'thriller',
    description: '深海科考站"深渊七号"在太平洋海沟底部发现了一处未知的古代遗迹。当科学家们兴奋地以为发现了人类文明的新篇章时，遗迹中沉睡的东西苏醒了。在万米深海之下，没有人能听到你的尖叫。',
    status: '连载中',
    rating: 4.6,
    views: 920000,
    updateTime: '2026-08-04',
    tags: ['深海', '科幻', '克苏鲁', '惊悚'],
    chapters: generateChapters(21, 33),
  },
  {
    id: 22,
    title: '面包店的四季',
    author: '崔智友',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20Korean%20slice%20of%20life%20webtoon%20cover%20showing%20a%20cozy%20neighborhood%20bakery%20with%20fresh%20bread%20displayed%2C%20a%20kind%20female%20baker%20smiling%2C%20cherry%20blossoms%20outside%20the%20window%2C%20golden%20morning%20light%2C%20peaceful%20nostalgic%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-22&orientation=portrait',
    category: 'slice-of-life',
    description: '在城市的一隅，有一家传了三代的面包店。店主朴奶奶用一生的时间烤制面包，也见证了无数人的悲欢离合。春天樱花飘落，夏日蝉鸣阵阵，秋天银杏满地，冬雪覆盖屋檐——面包店的四季，也是人生的四季。',
    status: '已完结',
    rating: 4.8,
    views: 720000,
    updateTime: '2026-04-30',
    tags: ['美食', '怀旧', '温情', '人生'],
    chapters: generateChapters(22, 30),
  },
  {
    id: 23,
    title: '黎明之前',
    author: '沈银河',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20BL%20webtoon%20cover%20showing%20two%20young%20men%20standing%20on%20a%20rooftop%20at%20dawn%2C%20city%20skyline%20in%20background%2C%20soft%20orange%20and%20pink%20sunrise%20colors%2C%20one%20holding%20a%20camera%2C%20tender%20and%20hopeful%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-23&orientation=portrait',
    category: 'bl',
    description: '摄影系学生郑河琳的毕业作品选题是"记录城市的黎明"，他每天凌晨四点背着相机在城市中穿梭。在一个偶然的清晨，他遇到了同样喜欢在黎明时分跑步的医学生安世勋，两颗孤独的心在黎明前相遇。',
    status: '连载中',
    rating: 4.5,
    views: 850000,
    updateTime: '2026-08-01',
    tags: ['大学', '摄影', '治愈', '慢热'],
    chapters: generateChapters(23, 35),
  },
  {
    id: 24,
    title: '皇后的复仇',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20drama%20webtoon%20cover%20with%20a%20queen%20in%20traditional%20royal%20hanbok%20standing%20in%20a%20palace%20hall%2C%20cold%20expression%2C%20holding%20a%20sealed%20letter%2C%20palace%20intrigue%20vibe%2C%20rich%20red%20and%20gold%20colors%2C%20historical%20manhwa%20art%20style%2C%20simple%20clean%20composition&width=600&height=840&seq=comic-cover-24&orientation=portrait',
    category: 'drama',
    description: '朝鲜时代的世子妃李素月在嫁入王室后不久便被诬陷毒害世子，含冤而死。重生后的她成为了当朝皇后，这一次她要用皇后的权力将当年的真相大白于天下，让所有参与陷害的人付出血的代价。',
    status: '连载中',
    rating: 4.8,
    views: 1760000,
    updateTime: '2026-08-05',
    tags: ['宫斗', '重生', '复仇', '历史'],
    chapters: generateChapters(24, 62),
  },
];

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.category === slug);
}

export function getPopularComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
}

export function getFeaturedComics(): Comic[] {
  return [comics[0], comics[2], comics[3], comics[7], comics[11]];
}